import { useEffect, useMemo, useState } from 'react';
import { IExercise, IExerciseAlternative } from '../../../models/exercise';
import { QuizExercise } from './Exercise';
import { toast } from '../../atoms/Toast';
import './scroll-bar.css';
import { useAnswerQuiz } from '../../../hooks/useAnswerQuiz';
import { IQuiz } from '../../../models/quiz';
import { Icon } from '../../atoms/Icon';

interface IPlayerQuizProps {
  quiz: IQuiz;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export function PlayerQuiz({ quiz, isOpen, setIsOpen }: IPlayerQuizProps) {
  const { answerQuiz, isError, error } = useAnswerQuiz();

  const [exercises, setExercises] = useState<IExercise[]>([]);
  const [currentExercise, setCurrentExercise] = useState<IExercise | null>(
    null
  );

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Erro ao responder o quiz',
        message: error?.message || 'Erro ao responder o quiz',
        variant: 'error',
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (quiz) {
      const mappedExercises = quiz.exercises.map((exercise) => {
        return {
          ...exercise,
          alternatives: exercise.alternatives.map((alternative) => ({
            ...alternative,
            id: alternative._id,
          })),
        };
      });
      setExercises(mappedExercises);
      setCurrentExercise(mappedExercises[0]);
    }
  }, [quiz]);

  const currentExerciseIndex = useMemo(() => {
    return exercises.findIndex(
      (exercise) => exercise.id === currentExercise?.id
    );
  }, [currentExercise, exercises]);

  const handleNextExercise = () => {
    setCurrentExercise(exercises[currentExerciseIndex + 1]);
  };

  const handlePreviousExercise = () => {
    setCurrentExercise(exercises[currentExerciseIndex - 1]);
  };

  const saveAnswer = (selectedAlternative: IExerciseAlternative) => {
    const newExercises = [...exercises];
    newExercises[currentExerciseIndex].answered = true;

    const newAlternatives = newExercises[currentExerciseIndex].alternatives.map(
      (alternative) => ({
        ...alternative,
        selected: alternative._id === selectedAlternative._id,
      })
    );

    newExercises[currentExerciseIndex].alternatives = newAlternatives;
    answerQuiz({
      quizId: quiz.id,
      exerciseId: currentExercise?.id || '',
      answerId: selectedAlternative._id,
      isCorrect: selectedAlternative.correct || false,
    });
    setExercises(newExercises);
  };

  if (!currentExercise) return null;

  return (
    <div className='overflow-y-auto h-full w-full flex flex-col justify-between bg-color-brand-primary'>
      <div className='pointer-events-auto justify-end px-8 pt-4 md:flex'>
        <button onClick={() => setIsOpen(false)} className='text-[#FFFFFF] text-lg'>
          <Icon Icon='close' type='material' />
        </button>
      </div>

      <QuizExercise
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        exercise={currentExercise}
        totalExercises={exercises.length}
        currentExerciseIndex={currentExerciseIndex}
        handleNextExercise={handleNextExercise}
        handlePreviousExercise={handlePreviousExercise}
        onShowCorrectAnswer={saveAnswer}
      />
    </div>
  );
}
